import axios from "axios";
import { toast } from "sonner";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("mm_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !e.config?.url?.includes("/auth/")) {
      localStorage.removeItem("mm_token");
      if (!window.location.pathname.startsWith("/login")) window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.message || d.msg || String(d);
}

const NO_PREVIEW = ["xlsx", "xls", "csv", "tsv", "doc", "ppt", "pptx", "msg", "eml"];
export const canPreview = (filename = "") => !NO_PREVIEW.includes(filename.includes(".") ? filename.split(".").pop().toLowerCase() : "");

export async function downloadDoc(doc, inline = false) {
  if (inline && !canPreview(doc.filename)) { toast.message("In-app preview is not available for this file type — downloading instead"); inline = false; }
  const res = await api.get(`/documents/${doc.id}/download${inline ? "?inline=1" : ""}`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  if (inline) { window.open(url, "_blank", "noopener"); return; }
  const a = document.createElement("a");
  a.href = url;
  a.download = doc.filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export default api;
